export const heroBanners = [
  {
    id: 1,
    title: '流浪地球3',
    subtitle: '2026暑期档巨制 · 科幻冒险大片',
    category: '电影',
    rating: '9.2',
    year: '2026',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20featuring%20a%20massive%20planet%20with%20glowing%20engines%20in%20deep%20space%20dramatic%20cinematic%20lighting%20with%20warm%20orange%20and%20cool%20teal%20contrast%20futuristic%20spaceships%20flying%20toward%20the%20planet%20against%20starry%20backdrop%208K%20resolution%20movie%20poster%20style&width=1600&height=600&seq=hero-1&orientation=landscape',
    link: '/category/dianying',
  },
  {
    id: 2,
    title: '庆余年 第二季',
    subtitle: '权谋史诗 · 口碑爆款古装剧回归',
    category: '电视剧',
    rating: '9.5',
    year: '2026',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20court%20drama%20poster%20with%20misty%20mountain%20landscape%20a%20lone%20figure%20in%20traditional%20flowing%20robes%20standing%20on%20palace%20rooftop%20at%20sunset%20golden%20hour%20lighting%20with%20dramatic%20clouds%20elegant%20Chinese%20painting%20aesthetics%20cinematic%20wide%20shot&width=1600&height=600&seq=hero-2&orientation=landscape',
    link: '/category/dianshiju',
  },
  {
    id: 3,
    title: '乘风破浪的姐姐 第六季',
    subtitle: '现象级综艺 · 姐姐们再度集结',
    category: '综艺',
    rating: '8.9',
    year: '2026',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20stage%20with%20colorful%20dynamic%20lighting%20effects%20multiple%20female%20performers%20in%20glamorous%20costumes%20on%20a%20grand%20stage%20with%20LED%20screen%20backdrop%20confetti%20falling%20energetic%20performance%20atmosphere%20professional%20studio%20photography&width=1600&height=600&seq=hero-3&orientation=landscape',
    link: '/category/zongyi',
  },
  {
    id: 4,
    title: '深海 2',
    subtitle: '国产动画新标杆 · 视觉奇观',
    category: '动漫',
    rating: '9.3',
    year: '2026',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stunning%20Chinese%20animated%20film%20poster%20featuring%20an%20underwater%20fantasy%20world%20with%20bioluminescent%20jellyfish%20and%20coral%20reefs%20a%20young%20character%20floating%20in%20deep%20ocean%20surrounded%20by%20magical%20glowing%20particles%20dreamlike%20atmosphere%20with%20rich%20blue%20and%20cyan%20tones%20digital%20art%20masterpiece&width=1600&height=600&seq=hero-4&orientation=landscape',
    link: '/category/dongman',
  },
];

export const categories = [
  { id: 'dianying', name: '电影', icon: 'ri-movie-2-line', count: 1280 },
  { id: 'dianshiju', name: '电视剧', icon: 'ri-tv-2-line', count: 960 },
  { id: 'zongyi', name: '综艺', icon: 'ri-live-line', count: 540 },
  { id: 'dongman', name: '动漫', icon: 'ri-ancient-pavilion-line', count: 720 },
];

export const hotRecommends = [
  {
    id: 1,
    title: '满江红2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20epic%20movie%20poster%20with%20grand%20ancient%20palace%20courtyard%20scene%20dramatic%20lighting%20with%20soldiers%20in%20armor%20standing%20in%20formation%20red%20lanterns%20hanging%20warm%20cinematic%20atmosphere%20intense%20dramatic%20mood&width=400&height=600&seq=hot-1&orientation=portrait',
    category: '电影',
    rating: '9.1',
    year: '2026',
    badge: '热播',
    link: '/category/dianying',
  },
  {
    id: 2,
    title: '三体：黑暗森林',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20poster%20featuring%20mysterious%20cosmic%20scene%20with%20dark%20forest%20metaphor%20three%20suns%20in%20alien%20sky%20silhouettes%20of%20figures%20in%20futuristic%20wasteland%20philosophical%20and%20profound%20atmosphere%20stark%20lighting%20contrast%20cinematic%20masterpiece&width=400&height=600&seq=hot-2&orientation=portrait',
    category: '电视剧',
    rating: '9.6',
    year: '2026',
    badge: '新剧',
    link: '/category/dianshiju',
  },
  {
    id: 3,
    title: '王牌对王牌 第九季',
    imageUrl: 'https://readdy.ai/api/search-image?query=Entertainment%20variety%20show%20stage%20with%20celebrity%20hosts%20and%20guests%20laughing%20together%20on%20colorful%20game%20show%20set%20with%20bright%20studio%20lighting%20fun%20competition%20atmosphere%20confetti%20and%20props%20on%20stage%20warm%20inviting%20entertainment%20vibe&width=400&height=600&seq=hot-3&orientation=portrait',
    category: '综艺',
    rating: '8.7',
    year: '2026',
    badge: '更新',
    link: '/category/zongyi',
  },
  {
    id: 4,
    title: '哪吒之魔童闹海2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20animated%20film%20poster%20featuring%20a%20rebellious%20young%20deity%20character%20with%20fire%20elements%20swirling%20around%20dramatic%20dynamic%20pose%20traditional%20Chinese%20art%20style%20blended%20with%20modern%20animation%20vibrant%20red%20and%20gold%20color%20scheme%20epic%20fantasy%20atmosphere&width=400&height=600&seq=hot-4&orientation=portrait',
    category: '动漫',
    rating: '9.4',
    year: '2026',
    badge: '热映',
    link: '/category/dongman',
  },
  {
    id: 5,
    title: '孤注一掷2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Thriller%20movie%20poster%20with%20intense%20atmosphere%20a%20figure%20looking%20through%20blinds%20in%20dimly%20lit%20room%20suspense%20mood%20with%20cool%20blue%20shadows%20and%20warm%20yellow%20light%20streaks%20noir%20cinematic%20style%20tension%20and%20mystery%20aesthetic&width=400&height=600&seq=hot-5&orientation=portrait',
    category: '电影',
    rating: '8.8',
    year: '2026',
    badge: '推荐',
    link: '/category/dianying',
  },
  {
    id: 6,
    title: '唐朝诡事录之西行',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tang%20dynasty%20mystery%20drama%20poster%20with%20ancient%20Chinese%20supernatural%20detective%20theme%20foggy%20mountain%20path%20with%20traditional%20architecture%20in%20background%20mysterious%20atmosphere%20with%20ethereal%20lighting%20ancient%20folklore%20aesthetic%20cinematic%20quality&width=400&height=600&seq=hot-6&orientation=portrait',
    category: '电视剧',
    rating: '9.0',
    year: '2026',
    badge: '热播',
    link: '/category/dianshiju',
  },
];

export const latestUpdates = [
  {
    id: 1,
    title: '繁花 第二季',
    imageUrl: 'https://readdy.ai/api/search-image?query=Shanghai%20nostalgia%20drama%20poster%20featuring%201990s%20Shanghai%20cityscape%20with%20neon%20lights%20and%20bustling%20streets%20figures%20in%20vintage%20clothing%20walking%20through%20rain-slicked%20streets%20warm%20amber%20glow%20reflecting%20off%20wet%20pavement%20romantic%20retro%20atmosphere&width=400&height=600&seq=latest-1&orientation=portrait',
    category: '电视剧',
    updateInfo: '更新至 24 集',
    year: '2026',
    link: '/category/dianshiju',
  },
  {
    id: 2,
    title: '熊出没·逆转时空',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20with%20two%20cute%20bears%20and%20a%20human%20character%20in%20a%20colorful%20sci-fi%20time%20travel%20setting%20with%20swirling%20clocks%20and%20wormholes%20playful%20adventure%20mood%20bright%20and%20cheerful%20colors%20family-friendly%20animation%20art&width=400&height=600&seq=latest-2&orientation=portrait',
    category: '动漫',
    updateInfo: '已完结',
    year: '2026',
    link: '/category/dongman',
  },
  {
    id: 3,
    title: '奔跑吧 第十二季',
    imageUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20variety%20show%20poster%20with%20celebrity%20cast%20running%20and%20laughing%20on%20a%20sunny%20beach%20setting%20bright%20natural%20lighting%20fun%20energetic%20vibe%20with%20colorful%20sportswear%20blue%20sky%20and%20ocean%20background%20joyful%20entertainment%20atmosphere&width=400&height=600&seq=latest-3&orientation=portrait',
    category: '综艺',
    updateInfo: '更新至 2026-07-31',
    year: '2026',
    link: '/category/zongyi',
  },
  {
    id: 4,
    title: '封神第二部',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20epic%20movie%20poster%20with%20grand%20scale%20battle%20scene%20ancient%20Chinese%20army%20with%20chariots%20and%20mythical%20beasts%20dramatic%20sky%20with%20lightning%20and%20fire%20epic%20fantasy%20war%20atmosphere%20massive%20scale%20cinematic%20illustration&width=400&height=600&seq=latest-4&orientation=portrait',
    category: '电影',
    updateInfo: '2026-08-15 上映',
    year: '2026',
    link: '/category/dianying',
  },
  {
    id: 5,
    title: '大江大河3',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20economic%20reform%20era%20drama%20poster%20featuring%20factory%20industrial%20landscape%20with%20workers%20in%20vintage%20workwear%20standing%20before%20massive%20machinery%20warm%20nostalgic%20tones%20documentary-style%20realism%20historical%20drama%20aesthetic&width=400&height=600&seq=latest-5&orientation=portrait',
    category: '电视剧',
    updateInfo: '更新至 36 集',
    year: '2026',
    link: '/category/dianshiju',
  },
  {
    id: 6,
    title: '雾山五行·犀川幻紫林',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20animation%20poster%20with%20martial%20arts%20figure%20wielding%20elemental%20fire%20powers%20in%20misty%20mountain%20bamboo%20forest%20traditional%20Chinese%20painting%20aesthetic%20with%20bold%20brush%20strokes%20dynamic%20action%20frozen%20in%20time%20artistic%20masterpiece&width=400&height=600&seq=latest-6&orientation=portrait',
    category: '动漫',
    updateInfo: '更新至 第5话',
    year: '2026',
    link: '/category/dongman',
  },
];

export const platformPartners = [
  {
    id: 1,
    name: '西瓜视频',
    description: '海量高清电影电视剧，每日更新不断，免费观看精彩内容',
    icon: 'ri-vidicon-line',
    color: 'bg-accent-500',
  },
  {
    id: 2,
    name: '芒果视频',
    description: '独家综艺节目、热门电视剧集，高清流畅不卡顿',
    icon: 'ri-tv-line',
    color: 'bg-secondary-500',
  },
  {
    id: 3,
    name: '蓝莓视频',
    description: '丰富动漫资源、经典电影大片，纯净无广告观影体验',
    icon: 'ri-play-circle-line',
    color: 'bg-primary-500',
  },
];

export const faqItems = [
  {
    question: '樱花视频是否需要注册登录？',
    answer: '不需要。樱花视频致力于为用户提供最便捷的观影体验，所有视频内容均可免费在线观看，无需注册登录，打开即可享受高清流畅的影视内容。',
  },
  {
    question: '观看视频会卡顿缓冲吗？',
    answer: '樱花视频采用先进的视频分发技术和多节点CDN加速，确保视频播放流畅不卡顿。同时我们与西瓜视频、芒果视频、蓝莓视频等平台深度合作，为用户提供最优的播放线路。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '樱花视频全面支持PC端、平板电脑和手机端浏览观看，页面自适应各种屏幕尺寸，无论您使用什么设备，都能获得优质的观影体验。',
  },
  {
    question: '视频画质如何？',
    answer: '樱花视频提供的影视内容支持高清画质（720P/1080P），部分热门内容更支持超清4K画质，让您在家也能享受影院级的视觉盛宴。',
  },
  {
    question: '内容多久更新一次？',
    answer: '樱花视频内容每日更新，热门电视剧同步跟播，电影新片及时上线。综艺节目和动漫内容也会在第一时间更新，确保用户不会错过任何精彩内容。',
  },
];